import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Container from '@mui/material/Container';
import { accent } from './darkFormStyles';
import { Link as RouterLink } from 'react-router-dom';

export default function DefaultFooter() {
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: '#fff',
        color: '#000',
        borderTop: `3px solid ${accent}`,
        mt: 'auto',
        width: '100%',
      }}
      id={'footer-box'}
    >
      <Container maxWidth="lg" sx={{ py: 6, px: { xs: 3, sm: 4 } }}>
        <Typography
          variant="body2"
          sx={{ textAlign: 'center', color: 'rgba(0,0,0,0.55)' }}
        >
          <Link
            component={RouterLink}
            to="/dashboard"
            sx={{
              color: accent,
              fontWeight: 'bold',
              textDecoration: 'none',
              '&:hover': { textDecoration: 'underline' },
            }}
          >
            Barbers Ltd
          </Link>{' '}
          {'© '} {new Date().getFullYear()} All Rights Reserved
        </Typography>
      </Container>
    </Box>
  );
}
